module.exports = __webpack_public_path__ + "static/media/fldc.522e6bad.svg";